import { z } from "zod";
import { stamps, Uuid } from "./common.js";

/** `POST /api/auth/login` body. */
export const LoginInput = z.object({
  email: z.email(),
  password: z.string().min(1),
});
export type LoginInput = z.infer<typeof LoginInput>;

/** Authenticated user (never carries the password hash). */
export const UserDto = z.object({
  id: Uuid,
  email: z.email(),
  name: z.string(),
  isActive: z.boolean(),
  ...stamps,
});
export type User = z.infer<typeof UserDto>;

/** `POST /api/users` body — the initial password is generated server-side. */
export const CreateUserInput = z.object({
  email: z.email(),
  name: z.string().min(1).max(200),
});
export type CreateUserInput = z.infer<typeof CreateUserInput>;

/** `POST /api/users` response: `initialPassword` is returned exactly once. */
export const CreatedUser = z.object({
  user: UserDto,
  initialPassword: z.string(),
});
export type CreatedUser = z.infer<typeof CreatedUser>;

/** `PATCH /api/users/:id/active` body. */
export const SetUserActiveInput = z.object({ isActive: z.boolean() });
export type SetUserActiveInput = z.infer<typeof SetUserActiveInput>;

/** `POST /api/auth/change-password` body. */
export const ChangePasswordInput = z.object({
  currentPassword: z.string().min(1),
  newPassword: z.string().min(8).max(200),
});
export type ChangePasswordInput = z.infer<typeof ChangePasswordInput>;
